import { render, staticRenderFns } from "./more_actions_dropdown.vue?vue&type=template&id=016b9f20"
import script from "./more_actions_dropdown.vue?vue&type=script&lang=js"
export * from "./more_actions_dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports